/**
 * Turning what a person typed into an address a URL can carry.
 *
 * Lives in its own module rather than beside the forms that use it: this is the function that
 * quietly decides what a course and a school are called for ever after, and a pure function
 * exported from a page component only gets tested by accident.
 */

const CYRILLIC_TO_LATIN: Record<string, string> = {
  а: 'a',
  б: 'b',
  в: 'v',
  г: 'g',
  д: 'd',
  е: 'e',
  ё: 'e',
  ж: 'zh',
  з: 'z',
  и: 'i',
  й: 'y',
  к: 'k',
  л: 'l',
  м: 'm',
  н: 'n',
  о: 'o',
  п: 'p',
  р: 'r',
  с: 's',
  т: 't',
  у: 'u',
  ф: 'f',
  х: 'h',
  ц: 'c',
  ч: 'ch',
  ш: 'sh',
  щ: 'sch',
  ъ: '',
  ы: 'y',
  ь: '',
  э: 'e',
  ю: 'yu',
  я: 'ya',
};

/**
 * "Школа JuniorProg" becomes "shkola-juniorprog".
 *
 * Transliteration rather than stripping: dropping the Cyrillic outright would leave a school
 * called «Школа» with an empty address, and the server would refuse it with a message about a
 * pattern the teacher never saw.
 */
export function slugify(name: string): string {
  return [...name.toLowerCase()]
    .map((ch) => CYRILLIC_TO_LATIN[ch] ?? ch)
    .join('')
    .replace(/[^a-z0-9]+/gu, '-')
    .replace(/^-+|-+$/gu, '')
    .slice(0, 63);
}
